const lgpdConsentText =
  'Ao prosseguir, você concorda que a Alice pode compartilhar seus dados com um corretor parceiro para apresentar os planos Alice'

export { lgpdConsentText }
